import {
  TableContainer,
  Paper,
  TableCell,
  TableRow,
  TableBody,
  Table,
  TableHead,
} from "@mui/material";
import { getFormattedHoursMinutes } from "reports/utils/timeUtils";
import styled from "styled-components/macro";
import {
  FONT_SIZE_SMALL,
  FONT_SIZE_EXTRA_SMALL,
} from "../../../constants/constants";

const USESummaryTableStyles = styled.div`
  padding: 4em 0;

  @media print {
    padding: 0em;
  }
`;

const StyledTable = styled(Table)`
  .sideHeader {
    background-color: lightgrey;
  }

  #titleCell {
    background-color: grey;
    color: white;
  }

  td {
    font-size: ${FONT_SIZE_SMALL}px;
    border-right: 1px lightgrey solid;
  }

  .lastCell {
    border-right: none;
  }

  @media print {
    td {
      padding: 2px 2px 0;
      font-size: ${FONT_SIZE_EXTRA_SMALL}px;
    }
  }
`;

const StyledTableHead = styled(TableHead)`
  background-color: lightgrey;

  .MuiTableCell-head {
    font-weight: 700;
    font-size: ${FONT_SIZE_SMALL}px;
    border-right: 1px lightgrey solid;
  }

  .lastCell {
    border-right: none;
  }

  .totalRow {
    background-color: white;
    font-weight: 900;
  }

  @media print {
    .MuiTableCell-head {
      font-weight: 300;
      font-size: ${FONT_SIZE_EXTRA_SMALL}px;
      padding: 2px 2px 0;
    }

    .totalRow {
      th {
        font-weight: 900 !important;
      }
    }
  }
`;

const formatTime = (timeMs: number): string => {
  const { hours, minutes } = getFormattedHoursMinutes(timeMs);
  const hourString = Number(hours) !== 0 ? `${hours}h` : "";
  return `${hourString} ${minutes}m`;
};

const RowCells = ({
  number,
  duration,
}: {
  number: number;
  duration: number;
}) => {
  return (
    <>
      <TableCell align="center">{number}</TableCell>
      <TableCell align="center">{formatTime(duration)}</TableCell>
      <TableCell align="center">{formatTime(duration / number)}</TableCell>
    </>
  );
};

export default function SterisSummaryTable({
  title,
  data,
  skipTotal = false,
}: {
  title: string;
  data: { [name: string]: { number: number; duration: number } };
  skipTotal?: boolean;
}) {
  const tagData = Object.entries(data)
    .filter(tagRow => tagRow[0] !== "total")
    .sort((a, b) =>
      a[1].duration < b[1].duration ? 1 : a[1].duration > b[1].duration ? -1 : 0
    );

  return (
    <USESummaryTableStyles>
      <TableContainer component={Paper}>
        <StyledTable size="small">
          <StyledTableHead>
            <TableRow>
              <TableCell
                id="titleCell"
                align="center"
                rowSpan={skipTotal ? 1 : 2}
              >
                {title}
              </TableCell>
              {["# of Events", "Duration", "Avg. Duration"].map(header => (
                <TableCell key={header} align="center">
                  {header}
                </TableCell>
              ))}
            </TableRow>
            <TableRow className="totalRow">
              {!skipTotal && <RowCells {...data.total} />}
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {tagData.map((tag, index) => {
              const name = tag[0];
              const value = tag[1];

              return (
                <TableRow key={value.number + value.duration}>
                  <TableCell align="center" className="sideHeader">
                    {name}
                  </TableCell>
                  <RowCells {...value} />
                </TableRow>
              );
            })}
          </TableBody>
        </StyledTable>
      </TableContainer>
    </USESummaryTableStyles>
  );
}
